import { TrackingContext, buttonPressed, errorViewed } from '@ps/web-shared-analytics';
import type { AvailableCashoutQuote, MyBet } from '@ps/web-sports-api-types';
import { useContext, useMemo } from 'react';

import { getEntities } from '../../../../../../../utils/getEntities';
import type { UnsuccessfulCashoutBetResponse } from '../types';

interface TrackCashOut {
  bet: MyBet;
  cashOutQuote: AvailableCashoutQuote;
}

type TrackCashOutWithButtonName = TrackCashOut & { buttonName: string };

const useTrackCashOut = () => {
  const trackingContext = useContext(TrackingContext);

  const trackers = useMemo(() => {
    const trackCashOut = ({ bet, cashOutQuote, buttonName }: TrackCashOutWithButtonName) => {
      const entities = getEntities(bet, cashOutQuote);

      buttonPressed({ ...trackingContext, entities }, { buttonName });
    };

    return {
      trackCashOut: ({ bet, cashOutQuote }: TrackCashOut) => {
        trackCashOut({ bet, cashOutQuote, buttonName: 'Cash Out' });
      },
      trackCashOutConfirm: ({ bet, cashOutQuote }: TrackCashOut) => {
        trackCashOut({ bet, cashOutQuote, buttonName: 'Cash Out Confirm' });
      },
      trackCashOutCancel: ({ bet, cashOutQuote }: TrackCashOut) => {
        trackCashOut({ bet, cashOutQuote, buttonName: 'Cash Out Cancel' });
      },
      getTrackCashOutError: ({ bet, cashOutQuote }: TrackCashOut) => {
        const entities = getEntities(bet, cashOutQuote);

        return (responseStatus?: UnsuccessfulCashoutBetResponse['respStatus']) => {
          errorViewed(
            { ...trackingContext, entities },
            { errorCode: responseStatus ?? 'NOT_SUPPLIED' }
          );
        };
      }
    };
  }, [trackingContext]);

  return trackers;
};

export default useTrackCashOut;
